export { default } from './VerifyShopLink'
